// import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
// import { CommonModule } from '@angular/common';
// import { HeaderComponent } from "../../header/header.component";
// import { CallcenterService } from 'src/app/services/callcenter.service';
// import { FormsModule } from '@angular/forms';
// import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'; // Import ngx-bootstrap modal

// @Component({
//   selector: 'app-callcenter-dashboard',
//   standalone: true,
//   imports: [CommonModule, HeaderComponent, FormsModule],
//   templateUrl: './callcenter-dashboard.component.html',
//   styleUrl: './callcenter-dashboard.component.scss',
//   providers: [
//     BsModalService // Provide BsModalService
//   ]
// })
// export class CallcenterDashboardComponent implements OnInit {
//   candidates: any[] = []; // Array to hold candidate data
//   currentPage: number = 1; // Current page for pagination
//   pageSize: number = 10; // Number of items per page (default)
//   pageSizeOptions: number[] = [10, 20, 30, 50, 100]; // Options for page size
//   totalItems: number = 0; // Total number of candidates

//   selectedStatus: string = ''; // Selected status in the modal
//   selectedCandidate: any = null; // Selected candidate for status update
//   remark: string = ''; // New property for remark
//   newSlot: string = ''; // New property for new slot

//   modalRef!: BsModalRef; // Reference to the modal
//   headerMessage: string = ''; // Message for modal header
//   bodyMessage: string = ''; // Message for modal body

//   @ViewChild('successTemplate') successTemplate!: TemplateRef<any>; // Reference to the success modal template
//   @ViewChild('failureTemplate') failureTemplate!: TemplateRef<any>; // Reference to the failure modal template

//   constructor(
//     private callcenterService: CallcenterService,
//     private modalService: BsModalService // Inject BsModalService
//   ) {}

//   ngOnInit(): void {
//     this.fetchCandidates();
//   }

//   // Fetch candidates from the server
//   fetchCandidates(): void {
//     this.callcenterService.getCandidates(this.currentPage, this.pageSize).subscribe(
//       (response) => {
//         console.log(response);
//         this.candidates = response.data?.data; // Assuming the response has a `data` field
//         this.totalItems = response.data?.totalRecords; // Assuming the response has a `totalRecords` field
//       },
//       (error) => {
//         console.error('Error fetching candidates:', error);
//       }
//     );
//   }

//   // Open a generic modal for success/failure messages
//   openModal(template: TemplateRef<any>, success: boolean, header: string, body: string): void {
//     this.headerMessage = success ? '✅ ' + header : '❌ ' + header;
//     this.bodyMessage = body;
//     this.modalRef = this.modalService.show(template);
//   }

//   // Open the status update modal
//   openStatusModal(candidate: any, template: TemplateRef<any>): void {
//     this.selectedCandidate = candidate;
//     this.selectedStatus = candidate.status;
//     this.remark = ''; // Reset remark when opening the modal
//     this.newSlot = ''; // Reset newSlot when opening the modal
//     this.modalRef = this.modalService.show(template);
//   }

//   // Handle status change to show/hide newSlot input
//   onStatusChange(): void {
//     if (this.selectedStatus !== 'Reschedule') {
//       this.newSlot = ''; // Clear newSlot if status is not Reschedule
//     }
//   }

//   // Get current date and time in the format required for the min attribute
//   getCurrentDateTime(): string {
//     const now = new Date();
//     const year = now.getFullYear();
//     const month = String(now.getMonth() + 1).padStart(2, '0');
//     const day = String(now.getDate()).padStart(2, '0');
//     const hours = String(now.getHours()).padStart(2, '0');
//     const minutes = String(now.getMinutes()).padStart(2, '0');
//     return `${year}-${month}-${day}T${hours}:${minutes}`;
//   }

//   // Format newSlot data as "YYYY-MM-DD HH:mm:ss"
//   formatNewSlot(dateTime: string): string {
//     const date = new Date(dateTime);
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0');
//     const day = String(date.getDate()).padStart(2, '0');
//     const hours = String(date.getHours()).padStart(2, '0');
//     const minutes = String(date.getMinutes()).padStart(2, '0');
//     const seconds = String(date.getSeconds()).padStart(2, '0');
//     return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
//   }

//   // Update the status of the selected candidate
//   updateStatus(): void {
//     if (this.selectedCandidate && this.selectedStatus) {
//       const empCode = this.selectedCandidate.empCode;
//       const status = this.selectedStatus;
//       const updatedDateTime = new Date().toISOString(); // Get current date and time in ISO format

//       const payload: any = {
//         status,
//         remark: this.remark,
//         updatedDateTime: this.formatNewSlot(updatedDateTime),
//       };

//       if (status === 'Reschedule' && this.newSlot) {
//         payload.newSlot = this.formatNewSlot(this.newSlot); // Format newSlot before sending
//       }

//       this.callcenterService.updateStatus(empCode, payload).subscribe(
//         (res: any) => {
//           console.log('API Response:', res); // Log the successful response

//           // Close the status update modal
//           this.modalRef.hide();

//           // Show success modal
//           this.openModal(this.successTemplate, true, 'Success', res.message || 'Status updated successfully.');

//           // Fetch updated candidate details
//           this.fetchCandidates();
//         },
//         (error: any) => {
//           console.error('API Error:', error); // Log the error

//           // Close the status update modal
//           this.modalRef.hide();

//           // Show failure modal
//           this.openModal(this.failureTemplate, false, 'Error', error.errorMessage || 'Failed to update status.');
//         }
//       );
//     }
//   }

//   // Handle page change event
//   onPageChange(page: number): void {
//     if (page >= 1 && page <= this.getTotalPages()) {
//       this.currentPage = page;
//       this.fetchCandidates();
//     }
//   }

//   // Handle page size change
//   onPageSizeChange(): void {
//     this.currentPage = 1; // Reset to first page when changing page size
//     this.fetchCandidates();
//   }

//   // Calculate total pages
//   getTotalPages(): number {
//     return Math.ceil(this.totalItems / this.pageSize);
//   }

//   // Generate an array of page numbers for pagination
//   getPages(): number[] {
//     const totalPages = this.getTotalPages();
//     const maxPagesToShow = 5; // Maximum number of pages to show in the pagination control
//     const halfMaxPages = Math.floor(maxPagesToShow / 2);
//     let startPage = Math.max(1, this.currentPage - halfMaxPages);
//     let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

//     if (endPage - startPage + 1 < maxPagesToShow) {
//       startPage = Math.max(1, endPage - maxPagesToShow + 1);
//     }

//     return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
//   }
// }

import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from "../../header/header.component";
import { CallcenterService } from 'src/app/services/callcenter.service';
import { FormsModule } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal'; // Import ngx-bootstrap modal
import { TooltipModule } from 'ngx-bootstrap/tooltip'; // Import TooltipModule from ngx-bootstrap
import { TruncatePipe } from 'src/app/pipes/truncate.pipe';

@Component({
  selector: 'app-callcenter-dashboard',
  standalone: true,
  imports: [CommonModule, HeaderComponent, FormsModule, TooltipModule, TruncatePipe], // Add TooltipModule here
  templateUrl: './callcenter-dashboard.component.html',
  styleUrl: './callcenter-dashboard.component.scss',
  providers: [
    BsModalService // Provide BsModalService
  ]
})
export class CallcenterDashboardComponent implements OnInit {
  candidates: any[] = []; // Array to hold candidate data
  currentPage: number = 1; // Current page for pagination
  pageSize: number = 10; // Number of items per page (default)
  pageSizeOptions: number[] = [10, 20, 30, 50, 100]; // Options for page size
  totalItems: number = 0; // Total number of candidates

  selectedStatus: string = ''; // Selected status in the modal
  selectedCandidate: any = null; // Selected candidate for status update
  remark: string = ''; // New property for remark
  newSlot: string = ''; // New property for new slot

  modalRef!: BsModalRef; // Reference to the modal
  headerMessage: string = ''; // Message for modal header
  bodyMessage: string = ''; // Message for modal body

  @ViewChild('successTemplate') successTemplate!: TemplateRef<any>; // Reference to the success modal template
  @ViewChild('failureTemplate') failureTemplate!: TemplateRef<any>; // Reference to the failure modal template

  constructor(
    private callcenterService: CallcenterService,
    private modalService: BsModalService // Inject BsModalService
  ) {}

  ngOnInit(): void {
    this.fetchCandidates();
  }

  // Fetch candidates from the server
  fetchCandidates(): void {
    this.callcenterService.getCandidates(this.currentPage, this.pageSize).subscribe(
      (response) => {
        console.log(response);
        this.candidates = response.data?.data; // Assuming the response has a `data` field
        this.totalItems = response.data?.totalRecords; // Assuming the response has a `totalRecords` field
      },
      (error) => {
        console.error('Error fetching candidates:', error);
      }
    );
  }

  // Open a generic modal for success/failure messages
  openModal(template: TemplateRef<any>, success: boolean, header: string, body: string): void {
    this.headerMessage = success ? '✅ ' + header : '❌ ' + header;
    this.bodyMessage = body;
    this.modalRef = this.modalService.show(template);
  }

  // Open the status update modal
  openStatusModal(candidate: any, template: TemplateRef<any>): void {
    this.selectedCandidate = candidate;
    this.selectedStatus = candidate.status;
    this.remark = ''; // Reset remark when opening the modal
    this.newSlot = ''; // Reset newSlot when opening the modal
    this.modalRef = this.modalService.show(template);
  }

  // Handle status change to show/hide newSlot input
  onStatusChange(): void {
    if (this.selectedStatus !== 'Reschedule') {
      this.newSlot = ''; // Clear newSlot if status is not Reschedule
    }
  }

  // Get current date and time in the format required for the min attribute
  getCurrentDateTime(): string {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  // Format newSlot data as "YYYY-MM-DD HH:mm:ss"
  formatNewSlot(dateTime: string): string {
    const date = new Date(dateTime);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  // Update the status of the selected candidate
  updateStatus(): void {
    if (this.selectedCandidate && this.selectedStatus) {
      const requestNumber = this.selectedCandidate.requestNumber;
      const status = this.selectedStatus;
      const updatedDateTime = new Date().toISOString(); // Get current date and time in ISO format

      const payload: any = {
        status,
        remark: this.remark,
        updatedDateTime: this.formatNewSlot(updatedDateTime),
      };

      if (status === 'Reschedule' && this.newSlot) {
        payload.newSlot = this.formatNewSlot(this.newSlot); // Format newSlot before sending
      }

      this.callcenterService.updateStatus(requestNumber, payload).subscribe(
        (res: any) => {
          console.log('API Response:', res); // Log the successful response

          // Close the status update modal
          this.modalRef.hide();

          // Show success modal
          this.openModal(this.successTemplate, true, 'Success', res.message || 'Status updated successfully.');

          // Fetch updated candidate details
          this.fetchCandidates();
        },
        (error: any) => {
          console.error('API Error:', error); // Log the error

          // Close the status update modal
          this.modalRef.hide();

          // Show failure modal
          this.openModal(this.failureTemplate, false, 'Error', error.errorMessage || 'Failed to update status.');
        }
      );
    }
  }

  // Handle page change event
  onPageChange(page: number): void {
    if (page >= 1 && page <= this.getTotalPages()) {
      this.currentPage = page;
      this.fetchCandidates();
    }
  }

  // Handle page size change
  onPageSizeChange(): void {
    this.currentPage = 1; // Reset to first page when changing page size
    this.fetchCandidates();
  }

  // Calculate total pages
  getTotalPages(): number {
    return Math.ceil(this.totalItems / this.pageSize);
  }

  // Generate an array of page numbers for pagination
  getPages(): number[] {
    const totalPages = this.getTotalPages();
    const maxPagesToShow = 5; // Maximum number of pages to show in the pagination control
    const halfMaxPages = Math.floor(maxPagesToShow / 2);
    let startPage = Math.max(1, this.currentPage - halfMaxPages);
    let endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }
}